import React from "react";
import "../../../components/BirthdayFlipCard.css";

export default function BirthdayFlipCard({
  name,
  employeeId,
  department,
  image,
  message,
  from
}) {
  return (
    <div className="birthday-flip-wrapper">
      <div className="card">
        <div className="back">
        

        </div>

        <div className="front">
          <div className="imgset">

            
            <img
              src={image}            /* ✅ USE PROP */
              alt="Birthday"
              width="100%"
            />
          </div>
        </div>

        

        <div className="text-container">
           <div className="bd-balloons">
        <span className="balloon b1"></span>
        <span className="balloon b2"></span>
        <span className="balloon b3"></span>
        <span className="balloon b4"></span>
        <span className="balloon b5"></span>
      </div>
          <p className="message">{message}</p>
          <p className="head"><strong>{name} ({employeeId})</strong><br/><strong>{department}</strong></p>
        
         
        </div>
      </div>
    </div>
  );
}
